import { useNavigate, useLocation } from 'react-router';
import { GoBackView, GoBackViewProps } from '@vivli/shared/views';

interface GoBackLinkComponentProps extends GoBackViewProps {
    destination?: string;
}

export const GoBackLinkComponent = ({ destination, textToShow = '< Go Back', style, dataId }: GoBackLinkComponentProps) => {
    const navigate = useNavigate();

    const handleGoBack = () => {
        if (destination) {
            navigate(destination);
        } else {
            window.history.back();
        }
    };

    return <GoBackView onButtonClick={handleGoBack} style={style} dataId={dataId} textToShow={textToShow} />;
};
